// import {select, selectAll} from 'd3-selection';
// import {scaleLinear, scaleTime} from 'd3-scale';
// import {axisBottom, axisLeft} from 'd3-axis';
// import {extent, max, min} from 'd3-array';
// import {line} from 'd3-shape';

// const d3 = {
// 	select,
// 	selectAll,
// 	extent,
// 	min,
// 	max,
// 	scaleLinear,
// 	scaleTime,
// 	axisBottom,
// 	axisLeft,
// 	line
// }

import * as d3 from 'd3';

class Overgewicht {

	constructor(data, states, ref) {
		console.log(data);
		this._data = data;
		this._states = states;
		this._ref = ref;

		this._margin = {left: 40, right: 10, top: 20, bottom: 40};
		this._width = parseInt(d3.select(this._ref).style("width")) - this._margin.left - this._margin.right;
		this._height = 460 - this._margin.top - this._margin.bottom;
	}


	maakGrafiek() {
		let data = this._data;

		data.forEach((d) => {
			d.defined = true;
		});

		this._yourData = data
			.map((d) => { 
				return {
					jaar: d.Jaar, 
					overgewicht: 0, 
					defined: 0
				} 
			})

		let margin = this._margin,
			width = this._width,
			height = this._height;

		this._svg = d3.select(this._ref)
			.append('svg')
				.attr("width", width + margin.left + margin.right)
				.attr("height", height + margin.top + margin.bottom)
				
		this._grafiek = this._svg.append("g")
			.attr("transform", "translate(" + ( margin.left) + "," + (margin.top) + ")");

		this._grafiek.append('rect')
			.attr('width', width)
			.attr('height', height)
			.style('opacity', 0)

		this._x = d3.scaleLinear()
			.domain([1995, 2020])
			.range([0, width])

		this._y = d3.scaleLinear()
			.domain([0, 20])
			.range([height, 0])

		this._xAxis = d3.axisBottom(this._x)
			.ticks(25)
			.tickFormat((d,i) => {
				return i%5 !== 0 ? " ": d;
			})

		this._yAxis = d3.axisLeft(this._y)
			.ticks(5)
			.tickFormat(d => d + '%')
			.tickSize(width * -1);

		this._lineKids = d3.area()
			.x(d => this._x(d.Jaar))
			.y(d => this._y(d.Jr4_11))
			.curve(d3['curveMonotoneX'])
			.defined(d => {
				return d.defined;
			})

		this._lineTeens = d3.area()
			.x(d => this._x(d.Jaar))
			.y(d => this._y(d.Jr12_17))
			.curve(d3['curveMonotoneX'])
			.defined(d => {
				if(d.Jaar < 1995) return;
				return d.defined;
			})

		this._lineUser = d3.area()
			.x(d => this._x(d.jaar))
			.y(d => this._y(d.overgewicht))
			.curve(d3['curveMonotoneX'])
			.defined(d => {
				if(d.Jaar < 1995) return;
				return d.defined;
			})

		this._kidsLine = this._grafiek.append("g")
			.style("visibility", "hidden");

		this._kidsLine.append('path')
			.datum(data)
			.attr('class', 'kids-line')
			.attr('d', d => this._lineKids(d))

		this._kidsLine.append("text")
			.attr("x", 10)
			.attr("y", this._y(data[0].Jr4_11) - 20)
			.text("4 tot 12 jaar")
			
		this._teensLine = this._grafiek.append("g")
			.style("visibility", "hidden");

		this._teensLine.append('path')
			.datum(data)
			.attr('class', 'teens-line')
			.attr('d', d => this._lineTeens(d))
			
		this._teensLine.append("text")
			.attr("class", "teens-text")
			.attr("x", 10)
			.attr("y", this._y(data[0].Jr12_17) + 30)
			.text("12 tot 18 jaar")

		this._userLine = this._grafiek.append("g")
			.style("visibility", "hidden");

		this._userLine.append('path')
			.datum(this._yourData)
			.attr('class', 'your-line')
			.attr('d', d => this._lineUser(d))
			
		this._xAxisG = this._grafiek.append("g")
			.call(this._xAxis)
			.attr("transform", `translate(0,${height})`)
					
		this._xAxisG.append('text')
			.attr('class', 'axis-label')
			.text('Jaar')
			.attr('x', width /2)
			.attr('y', 40)

		this._yAxisG = this._grafiek.append("g")
			.call(this._yAxis)
			.call(g => g.select(".domain").remove())
			.call(g => g.select(".tick:last-of-type text").clone()
				.attr("x", margin.left * -1)
				.attr("y", -20)
				.attr("text-anchor", "start")
				.attr("font-weight", "bold")
				.text('Percentage kinderen met overgewicht'))
		
		

		const onDraw = (event) => {
			if (event.touches) { //fix touch
				event = event.touches[0];
			}

			var pos = d3.pointer(event, this._grafiek.node());

			var jaar = clamp(this._x.domain()[0], this._x.domain()[1], this._x.invert(pos[0]))
			var overgewicht = clamp(0, this._y.domain()[1], this._y.invert(pos[1]))

			this._yourData.forEach(function(d){
				if (Math.abs(d.jaar - jaar) < 1){
					d.overgewicht = overgewicht
					d.defined = true
				}
			});

			this._userLine.select("path")
				.datum(this._yourData)
				.attr('d', this._lineUser)
		}

		var drag = d3.drag()
			.on('drag', (event) => {
				onDraw(event);
			})

		this._grafiek.call(drag)

		this._grafiek.select("rect").on('touchmove', (event, d) => {
			onDraw(event);
		})

		this._grafiek.on('click', (event, d) => {
			onDraw(event);
		})

		function clamp(a, b, c){ return Math.max(a, Math.min(b, c)) }
	}

	changeState(currentState) {
		if (this._states[currentState].user_line === "hidden") {
			this._yourData.forEach(function(d){
				d.defined = false;
			});

			this._userLine.select("path")
				.datum(this._yourData)
				.attr('d', this._lineUser);
		}

		this._kidsLine.style("visibility", this._states[currentState].kids_line);
		this._teensLine.style("visibility", this._states[currentState].teens_line);
		this._userLine.style("visibility", this._states[currentState].user_line);
	}

	resize() {
		this._width = parseInt(d3.select(this._ref).style("width")) - this._margin.left - this._margin.right;

		this._svg
			.attr("width", this._width + this._margin.left + this._margin.right)

		this._x
			.range([0, this._width])

		this._grafiek.select('rect')
			.attr('width', this._width)

		this._xAxisG
			.call(this._xAxis)

		this._yAxis
			.tickSize(this._width * -1);

		this._yAxisG
			.call(this._yAxis)

		this._kidsLine.select("path")
			.attr('d', d => this._lineKids(d));

		this._teensLine.select('path')
			.attr('d', d => this._lineTeens(d));

		this._userLine.select("path")
			.attr('d', d => this._lineUser(d));
	}

}

export default Overgewicht;